import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ParagonUninstallRequest } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

/**
 * Retires a CRM install the user disconnected in Paragon. Paragon does not notify the integrations
 * service, so without this the company keeps an active CRM whose credentials are gone.
 */
export function useRemoveParagonInstall() {
  const api = useIntegrationApi();
  const queryClient = useQueryClient();

  return useMutation(
    (paragonUninstallRequest: ParagonUninstallRequest) =>
      api.removeParagonInstall({ paragonUninstallRequest }),
    {
      // As for recording one: the cached install outlives the connection without this.
      onSuccess: () => queryClient.invalidateQueries({ queryKey: ["integrationProvider"] }),
    },
  );
}
